import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, Scrollbar, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

if (document.querySelector(".testimonial-slider__inner")) {
    $(".testimonial-slider__inner").each(function () {
        new Swiper(this, {
            modules: [Navigation, Pagination],

            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 64,
            centeredSlides: false,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,

            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },

            pagination: {
                el: ".swiper-testimonials",
                clickable: true,
            },

            breakpoints: {
                0: {
                    slidesPerView: 1,
                    centeredSlides: true,
                },
                1024: {
                    slidesPerView: 2,
                    centeredSlides: false,
                },
            },
        });
    });
}
if ($(".slider-featured-pages").length) {
    $(".slider-featured-pages").each(function () {
        const paginationEl = this.querySelector(".slider-featured-pages__pagination");

        new Swiper(this, {
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: ".right-arrow",
                prevEl: ".left-arrow",
            },
            slidesPerView: 1.2,
            spaceBetween: 20,
            pagination: { el: paginationEl, clickable: true },
            simulateTouch: true,
            touchEventsTarget: "container",
            mousewheel: false,
            keyboard: true,
            breakpoints: {
                515: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 2.5, spaceBetween: 20 },
                1024: { slidesPerView: 3, spaceBetween: 20 },
                1280: { slidesPerView: 4, spaceBetween: 20 },
                1440: { slidesPerView: 4, spaceBetween: 20 },
            },
        });
    });
}
if ($(".slider-featured-articles").length) {
    $(".slider-featured-articles").each(function () {
        const paginationEl = this.querySelector(".slider-featured-pages__pagination");

        new Swiper(this, {
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: ".right-arrow",
                prevEl: ".left-arrow",
            },
            slidesPerView: 1.2,
            spaceBetween: 20,
            pagination: { el: paginationEl, clickable: true },
            simulateTouch: true,
            touchEventsTarget: "container",
            mousewheel: false,
            keyboard: true,
            breakpoints: {
                515: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 2.5, spaceBetween: 20 },
                1024: { slidesPerView: 3, spaceBetween: 20 },
                1280: { slidesPerView: 4, spaceBetween: 20 },
                1440: { slidesPerView: 4, spaceBetween: 20 },
            },
        });
    });
}

if ($(".articles-slider").length) {
    let articlesSlider = new Swiper(".articles-slider", {
        slidesPerView: 1.4,
        spaceBetween: 12,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        navigation: {
            nextEl: ".articles-slider__next",
            prevEl: ".articles-slider__prev",
        },
        pagination: {
            el: ".articles-slider__pagination",
            clickable: true,
        },
        scrollbar: {
            hide: false,
            draggable: true,
            el: ".articles-slider__scrollbar",
        },
        mousewheel: true,
        keyboard: true,

        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 10,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                // freeMode: false,
            },

            1024: {
                slidesPerView: 2.5,
                spaceBetween: 16,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                // freeMode: false,
            },
            1280: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                // freeMode: false,
            },
            1600: {
                slidesPerView: 1.4,
                spaceBetween: 24,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                // freeMode: false,
            },
        },
    });
}

if ($(".gallery_slider").length) {
    $(".gallery_slider").each(function () {
        let slice_id = $(this).data("slice-id");
        if (
            $(this).find($(".gallery-thumbs-" + slice_id)).length &&
            $(this).find($(".gallery-top-" + slice_id)).length
        ) {
            //   THUMBS SLIDER
            var galleryThumbs = new Swiper(".gallery-thumbs-" + slice_id, {
                spaceBetween: 8,
                slidesPerView: 3,
                centerInsufficientSlides: true,
                // autoplay: true,
                // autoplay: {
                //     speed: 500,
                //     delay: 2500,
                // },
                loop: true,
                centerMode: true,
                centeredSlides: true,
                loopedSlides: 5,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,

                breakpoints: {
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 5,
                    },
                    1280: {
                        slidesPerView: 5,
                        spaceBetween: 14,
                    },
                },
            });
            //   BOG IMG SLIDER
            var galleryTop = new Swiper(".gallery-top-" + slice_id, {
                spaceBetween: 10,
                loop: true,
                slidesPerView: 1,
                autoplay: {
                    speed: 500,
                    delay: 2500,
                },
                loopedSlides: 5,
                thumbs: {
                    thumbsContainerClass: ".gallery-thumbs-" + slice_id,
                    swiper: galleryThumbs,
                    slideThumbActiveClass: "border border-yellow border-2",
                },
            });
        }
    });
}

if ($(".gallery-product").length) {
    if ($(".gallery-thumbs-product").length) {
        //   THUMBS SLIDER
        var galleryProdThumbs = new Swiper(".gallery-thumbs-product", {
            spaceBetween: 8,
            slidesPerView: 3,
            centerInsufficientSlides: true,
            // autoplay: true,
            // autoplay: {
            //     speed: 500,
            //     delay: 2500,
            // },
            loop: true,
            centerMode: true,
            centeredSlides: true,
            loopedSlides: 5,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,

            breakpoints: {
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 5,
                },
                1280: {
                    slidesPerView: 5,
                    spaceBetween: 14,
                },
            },
        });
        //   BOG IMG SLIDER
        var galleryTop = new Swiper(".gallery-product", {
            spaceBetween: 10,
            loop: true,
            slidesPerView: 1,
            autoplay: {
                speed: 500,
                delay: 2500,
            },
            loopedSlides: 5,
            thumbs: {
                thumbsContainerClass: ".gallery-thumbs-product",
                swiper: galleryProdThumbs,
                slideThumbActiveClass: "border border-yellow border-2",
            },
        });
    }
}

if ($(".logos-slider").length) {
    let articlesSlider = new Swiper(".logos-slider", {
        slidesPerView: 2,
        spaceBetween: 10,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,

        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 10,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                // freeMode: false,
            },

            1024: {
                slidesPerView: 6,
                spaceBetween: 10,
                slidesOffsetBefore: 5,
                slidesOffsetAfter: 5,
                // freeMode: false,
            },
            1200: {
                slidesPerView: 6,
                spaceBetween: 10,
                slidesOffsetBefore: 5,
                slidesOffsetAfter: 5,
                // freeMode: false,
            },
        },
    });
}

//static page swiper sliders
if ($(".product-icons-swiper").length) {
    new Swiper(".product-icons-swiper", {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination-accent",
            clickable: true,
        },
        breakpoints: {
            1024: {
                enabled: false,
            },
        },
    });
}

// Sectors Swiper
if (document.querySelector('.sectors-swiper')) {
    new Swiper('.sectors-swiper', {
        modules: [Pagination, Navigation],
        slidesPerView: 1.2,
        autoHeight: false,
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        slidesPerGroup: 1,
        slidesOffsetAfter: 30,
        pagination: {
            el: '.swiper-pagination-sectors',
            clickable: true,
        },
        navigation: {
            nextEl: ".sectors-slider__next",
            prevEl: ".sectors-slider__prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                autoHeight: false,
                spaceBetween: 24,
                slidesOffsetAfter: 120,
            },
            1024: {
                slidesPerView: 3.3,
                autoHeight: false,
                spaceBetween: 24,
                slidesOffsetAfter: 120,
            },
            1800: {
                slidesPerView: 4,
                autoHeight: false,
                spaceBetween: 24,
                slidesOffsetAfter: 200,
            },
        },
    });
}

